import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewSale from "@/pages/NewSale";
import Sales from "@/pages/Sales";
import Products from "@/pages/Products";
import Catalogs from "@/pages/Catalogs";
import Campaigns from "@/pages/Campaigns";
import Targets from "@/pages/Targets";
import Users from "@/pages/Users";
import Branches from "@/pages/Branches";
import Reports from "@/pages/Reports";
import Comparison from "@/pages/Comparison";
import Payroll from "@/pages/Payroll";
import Wallet from "@/pages/Wallet";
import LivePanel from "@/pages/LivePanel";
import IdArchive from "@/pages/IdArchive";
import DayEnd from "@/pages/DayEnd";
import Roles from "@/pages/Roles";
import Profile from "@/pages/Profile";
import Ypp from "@/pages/Ypp";
import SettingsPage from "@/pages/Settings";
import Opening from "@/pages/Opening";
import { ThemeSync } from "@/components/ThemeSync";
import { useMode } from "@/lib/theme";
import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

function AppToaster(props) {
  return <Toaster theme={useMode()} {...props} />;
}

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <AppShell>{children}</AppShell>
    </ProtectedRoute>
  );
}

function Home() {
  const { user } = useAuth();
  const mobile = window.innerWidth < 768;
  // NOTE: flag must NOT be set during render (StrictMode double-render would set it before the
  // committed render, cancelling the redirect). It is set in MobileSaleRedirect's effect instead.
  if (mobile && ["personel", "mudur"].includes(user?.role) && !sessionStorage.getItem("home_redirected")) {
    return <MobileSaleRedirect />;
  }
  return <Dashboard />;
}

function MobileSaleRedirect() {
  useEffect(() => { sessionStorage.setItem("home_redirected", "1"); }, []);
  return <Navigate to="/sales/new" replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ThemeSync />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Shell><Home /></Shell>} />
            <Route path="/id-archive" element={
              <ProtectedRoute allow={["koordinator", "patron", "mudur"]}><AppShell><IdArchive /></AppShell></ProtectedRoute>
            } />
            <Route path="/live" element={<Shell><LivePanel /></Shell>} />
            <Route path="/day-end" element={<Shell><DayEnd /></Shell>} />
            <Route path="/opening" element={<Shell><Opening /></Shell>} />
            <Route path="/roles" element={<Shell><Roles /></Shell>} />
            <Route path="/ypp" element={<Shell><Ypp /></Shell>} />
            <Route path="/settings" element={<Shell><SettingsPage /></Shell>} />
            <Route path="/profile" element={<Shell><Profile /></Shell>} />
            <Route path="/profile/:uid" element={<Shell><Profile /></Shell>} />
            <Route path="/sales/new" element={<Shell><NewSale /></Shell>} />
            <Route path="/sales" element={<Shell><Sales /></Shell>} />
            <Route path="/products" element={
              <ProtectedRoute allow={["koordinator", "patron"]}><AppShell><Products /></AppShell></ProtectedRoute>
            } />
            <Route path="/catalogs" element={
              <ProtectedRoute allow={["koordinator", "patron"]}><AppShell><Catalogs /></AppShell></ProtectedRoute>
            } />
            <Route path="/campaigns" element={
              <ProtectedRoute allow={["koordinator", "patron"]}><AppShell><Campaigns /></AppShell></ProtectedRoute>
            } />
            <Route path="/targets" element={
              <ProtectedRoute allow={["koordinator", "patron", "mudur", "personel"]}><AppShell><Targets /></AppShell></ProtectedRoute>
            } />
            <Route path="/users" element={
              <ProtectedRoute allow={["koordinator", "patron"]}><AppShell><Users /></AppShell></ProtectedRoute>
            } />
            <Route path="/branches" element={
              <ProtectedRoute allow={["koordinator", "patron"]}><AppShell><Branches /></AppShell></ProtectedRoute>
            } />
            <Route path="/reports" element={<Shell><Reports /></Shell>} />
            <Route path="/comparison" element={
              <ProtectedRoute allow={["koordinator", "patron", "mudur"]}><AppShell><Comparison /></AppShell></ProtectedRoute>
            } />
            <Route path="/payroll" element={
              <ProtectedRoute allow={["koordinator", "patron", "mudur", "personel"]}><AppShell><Payroll /></AppShell></ProtectedRoute>
            } />
            <Route path="/wallet" element={<Shell><Wallet /></Shell>} />
          </Routes>
        </BrowserRouter>
        <AppToaster position={window.innerWidth < 1024 ? "bottom-center" : "top-right"} offset={window.innerWidth < 1024 ? 112 : undefined} duration={2500} richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
